import styled from 'styled-components';

export const FindPasswordStyled = styled.div`
  padding: 30px 0px;
  display: flex;
  flex-direction: column;
  gap: 30px;
  width: 270px;
  justify-content: center;
  margin: 0 auto;
`;
